import {FETCH_DASHBOARD_COMMANDER, RECEIVE_DASHBOARD_COMMANDER, FAILED_DASHBOARD_COMMANDER} from '../../actions/dashboard/aDashboard-Commander'
import provinces from '../../../assets/satuan/provinces.json'

const defaultDashboardCommander = {
    organization: [],
    report: [],
    topology: [],
}

export function fetchCommanderDashboard(state = defaultDashboardCommander, action){
    switch(action.type){
        case FETCH_DASHBOARD_COMMANDER:
            return({organization: [], report: [], topology: [], inProgress: true})
        case RECEIVE_DASHBOARD_COMMANDER:
            console.log(action.payload)
            let geometries = []
            // if (action.payload != undefined){
            //     action.payload.organization.filter(x => x.organization_id == 1)[0].division.foEach((division, index) => {
            //         geometries.push({
            //             arcs: division.arcs,
            //             type: "MultiPolygon",
            //             properties: {
            //                 name: division.division_name,
            //                 base_x: division.x,
            //                 base_y: division.y,
            //             }
            //         })
            //     })
            // }
            
            //let padmaTopo = null
            // padmaTopo = {
            //     arcs: provinces.arcs,
            //     transform: provinces.transform,
            //     type: "Topology",
            //     objects: {
            //         divisions: {
            //             type: "GeometryCollection",
            //             geometries: geometries
            //         }
            //     }
            // }
            return Object.assign({}, state, {organization: action.payload.organization, report: action.payload.report, topology: geometries, inProgress: false})
        case FAILED_DASHBOARD_COMMANDER:
            return({organization: [], report: [], topology: [], inProgress: false})
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/dashboard/redDashboard-Commander.jsx